import { Box, CircularProgress } from '@mui/material';
import React from 'react';

type LoaderProps = {
  ariaBusy: boolean;
  loadingText?: string;
};

const Loader = ({ ariaBusy, loadingText = 'Loading Data' }: LoaderProps) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '96px',
    }}
  >
    <CircularProgress
      aria-label={loadingText}
      aria-live="polite"
      aria-busy={ariaBusy}
      data-testid="loading-icon"
      sx={{ color: 'text.secondary' }}
    />
  </Box>
);

export default Loader;
